import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Capitalizes the first letter of each word in a name
 * @param name - The name to capitalize
 * @returns The name with each word capitalized
 */
export function capitalizeWords(name: string | null | undefined): string {
  if (!name) return '';
  
  return name
    .trim()
    .split(/\s+/) // Split on any whitespace
    .map(word => {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
